import { FeedKindPage } from '../components/FeedKindPage';

export function NewsFeedPage() {
  return (
    <FeedKindPage
      kind="news"
      title="News Feed"
      description="Industry news from your configured RSS / news sources."
    />
  );
}
